import {React, useEffect, useState} from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';

import './App.css';
import LandingPage from './components/LandingPage/LandingPage';
import Login from './components/Login/Login';
import Signup from './components/Login/Signup';
import Dashboard from './components/Dashboard/Dashboard';
import DashboardGrid from './components/Dashboard/DashboardGrid';
import AboutUs from './components/Navigation/AboutUs';
import LegalPage from './components/LegalPage/LegalPage';
import Settings from './components/Settings/Settings';
import Level from './components/Level/Level';
import Chapter from './components/Chapter/Chapter';
import Exam from './components/Exam/Exam';
import Test from './components/Exam/Test';
import { isAuthenticated, getCurrentUser, getUserSettings } from './api/users_institutions';

function App() {
  useEffect(() => {
    // Load theme on app mount if user is authenticated
    const loadTheme = async () => {
      if (isAuthenticated()) {
        const user = getCurrentUser();
        if (user) {
          try {
            const settings = await getUserSettings(user.id);
            document.documentElement.setAttribute('data-theme', settings.theme);
          } catch (error) {
            console.error('Error loading theme:', error);
            // Default to light theme
            document.documentElement.setAttribute('data-theme', 'light');
          }
        }
      }
    };
    loadTheme();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage/>} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/dashboard" element={<Dashboard />}>
            <Route index element={<DashboardGrid />} />
            <Route path=":levelName" element={<Level />} />
          </Route>
          <Route path="/dashboard/:levelName/chapters/:chapterTitle" element={<Chapter />} />
          <Route path="/dashboard/:levelName/exams/:examName" element={<Exam />} />
          <Route path="/dashboard/:levelName/:topicName/tests/:testName" element={<Test />} />
          <Route path="/about_us" element={<AboutUs />} />
          <Route path="/privacy-policy" element={<LegalPage />} />
          <Route path="/profile/:username" element={<Settings />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
